import React from "react";
import heroImg from "../assets/img/ea-hero.svg";
import logo from "../assets/img/2.svg"
import main from "../assets/img/5.svg"
import f1 from "../assets/img/f1.jpeg"
import kp from "../assets/img/kp.jpeg"

// components

import Navbar from "components/Navbars/AuthNavbar.js";
// import Footer from "components/Footers/Footer.js";

export default function Landing() {
    React.useEffect(() => {
        window.analytics.track("EA Kampala Visit");
    }, []);
    return (
        <>
            <Navbar transparent />
            <main className="bg-blueGray-200">
                <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75 ">
                    <div
                        className="absolute top-0 w-full h-full bg-center bg-cover"
                        style={{
                            backgroundImage: `url(${kp})`,
                        }}
                    >
                        <span
                            id="blackOverlay"
                            className="w-full h-full absolute opacity-75 bg-black"
                        ></span>
                    </div>
                    <div className="container relative mx-auto">
                        <div className="items-center flex flex-wrap">
                            <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
                                <div className="">
                                    <h1 className="text-white font-semibold text-5xl">
                                        Effective Altruism
                                    </h1>
                                    <br />
                                    <h1 className="text-white font-semibold text-2xl">
                                        Kampala - Uganda Chapter
                                        <br />
                                    </h1>
                                    <p className="mt-4 text-lg text-blueGray-200">
                                        Effective altruism is a philosophy and community focused on maximising the good you can do through your career, projects, and donations.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div
                        className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
                        style={{ transform: "translateZ(0)" }}
                    >
                        <svg
                            className="absolute bottom-0 overflow-hidden"
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className=" fill-current"
                                points="2560 0 2560 100 0 100"
                            ></polygon>
                        </svg>
                    </div> */}
                </div>

                <section className="pb-20 bg-blueGray-200 -mt-24">
                    <div className="container mx-auto px-4">
                        {/* <div className="flex flex-wrap">
                            <div className="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center">
                                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                    <div className="px-4 py-5 flex-auto">
                                        <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
                                            <i className="fas fa-award"></i>
                                        </div>
                                        <h6 className="text-xl font-semibold">Awarded Agency</h6>
                                        <p className="mt-2 mb-4 text-blueGray-500">
                                            Divide details about your product or agency work into
                                            parts. A paragraph describing a feature will be enough.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="w-full md:w-4/12 px-4 text-center">
                                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                    <div className="px-4 py-5 flex-auto">
                                        <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400">
                                            <i className="fas fa-retweet"></i>
                                        </div>
                                        <h6 className="text-xl font-semibold">Free Revisions</h6>
                                        <p className="mt-2 mb-4 text-blueGray-500">
                                            Keep you user engaged by providing meaningful information.
                                            Remember that by this time, the user is curious.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="pt-6 w-full md:w-4/12 px-4 text-center">
                                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
                                    <div className="px-4 py-5 flex-auto">
                                        <div className="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400">
                                            <i className="fas fa-fingerprint"></i>
                                        </div>
                                        <h6 className="text-xl font-semibold">Verified Company</h6>
                                        <p className="mt-2 mb-4 text-blueGray-500">
                                            Write a few lines about each one. A paragraph describing a
                                            feature will be enough. Keep you user engaged!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className="flex flex-wrap items-center mt-32">
                            <div className="w-full md:w-5/12 px-4 mr-auto ml-auto">
                                <div className="text-blueGray-500 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-white">
                                    {/* <i className="fas fa-user-friends text-xl"></i> */}
                                    <img
                                        src={logo}
                                        alt="..."
                                    />
                                </div>
                                <h3 className="text-3xl mb-2 font-semibold leading-normal">
                                    What is Effective Altruism?
                                </h3>
                                <p className="text-lg font-light leading-relaxed mt-4 mb-4 text-blueGray-600">
                                    Everyone wants to do good, but many ways of doing good are ineffective or
                                    <a
                                        href="https://www.vox.com/future-perfect/2019/6/5/18629801/emergency-in-india-1975-indira-gandhi-sterilization-ford-foundation"
                                        className="text-lightBlue-500 font-semibold"
                                    >
                                        {" "}actively harmful.
                                    </a>
                                    <br />
                                    The EA movement arose out of a desire to make sure that attempts to do good actually work.
                                    <br />
                                </p>
                                <p
                                    className="text-lg leading-relaxed mt-4 mb-4 text-dark font-bold"
                                >
                                    This led to many ideas like the following:
                                </p>
                                <li className="text-black-500 text-lg">
                                    When choosing what to fund or work on, we shouldn't go for what's most personal or accessible to us.
                                </li>
                                <li className="text-black-500 text-lg">
                                    We should focus on problems that are
                                    <a
                                        href="https://80000hours.org/articles/problem-framework/"
                                        className="text-lightBlue-500 font-semibold"
                                    >
                                        {" "}important, neglected, and tractable{" "}
                                    </a>
                                    (which we can actually do something about).
                                </li>
                                <li className="text-black-500 text-lg">
                                    We should
                                    <a
                                        href="https://www.givewell.org/"
                                        className="text-lightBlue-500 font-semibold"
                                    >
                                        {" "} evaluate the work that charities do,{" "}
                                    </a>
                                    and value transparency and good evidence.
                                </li>

                                <li className="text-black-500 text-lg">
                                    Our time is valuable, and
                                    <a
                                        href="https://80000hours.org/"
                                        className="text-lightBlue-500 font-semibold"
                                    >
                                        {" "}we can do a lot of good with our careers.
                                    </a>
                                </li>
                                <li className="text-black-500 text-lg">
                                    The world is
                                    <a
                                        href="https://80000hours.org/articles/existential-risks/"
                                        className="text-lightBlue-500 font-semibold"
                                    >
                                        {" "}
                                        threatened by existential risks, and making it safer might be a key priority.
                                    </a>
                                    is ignored because they don't look like us or are far away
                                </li>
                                <li className="text-black-500 text-lg mb-8">
                                    The
                                    <a
                                        href="https://80000hours.org/problem-profiles/factory-farming/"
                                        className="text-lightBlue-500 font-semibold"
                                    >
                                        {" "}
                                        suffering of some sentient beings
                                        {" "}
                                    </a>
                                    is ignored because they don't look like us or are far away
                                </li>
                                <a
                                    className="ea-blue hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    onClick={() => {
                                        window.location.href = "https://www.effectivealtruism.org/articles/introduction-to-effective-altruism"
                                    }}
                                    href="https://www.effectivealtruism.org/articles/introduction-to-effective-altruism"
                                >
                                    Read Our Intro
                                    <i className="fas fa-arrow-circle-right ml-2"></i>
                                </a>
                            </div>

                            <div className="w-full md:w-4/12 px-4 mr-auto ml-auto">
                                <div className="relative flex flex-col min-w-0 break-words  w-full mb-6 shadow-lg rounded-lg ea-blue">
                                    <img
                                        alt="..."
                                        // src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80"
                                        src={main}
                                        className="w-full align-middle rounded-t-lg"
                                    />
                                    <blockquote className="relative pt-8 px-6 pb-0 mb-4">
                                        <h4 className="text-xl font-bold text-white">
                                            {/* Join EA at Kampala */}
                                            Our Next Cohort Begins in January 2023
                                        </h4>
                                        <p className="text-md font-light mt-2 text-white">
                                            {/* Our Next Cohort Begins in January 2023 */}
                                        </p>
                                    </blockquote>
                                </div>
                                <div
                                    className="mx-auto my-5 text-center"
                                >
                                    <a
                                        className="bg-emerald-500 text-white text-center p-4 mb-4 mt-4 outline-none focus:outline-none"
                                        style={{
                                            borderRadius: "24px",
                                            cursor: "pointer",
                                        }}
                                        href="https://fps2mesthin.typeform.com/to/GNGoQrfk"
                                        target='_blank'
                                        rel="noreferrer"
                                        hidden
                                    >
                                        Register Today
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section className="relative py-20">
                    <div
                        className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
                        style={{ transform: "translateZ(0)" }}
                    >
                        <svg
                            className="absolute bottom-0 overflow-hidden"
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="text-white fill-current"
                                points="2560 0 2560 100 0 100"
                            ></polygon>
                        </svg>
                    </div>

                    <div className="container mx-auto px-4">
                        <div className="items-center flex flex-wrap">
                            <div className="w-full md:w-4/12 ml-auto mr-auto px-4">
                                <img
                                    alt="..."
                                    className="max-w-full rounded-lg shadow-lg"
                                    src="https://images.unsplash.com/photo-1555212697-194d092e3b8f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80"
                                />
                            </div>
                            <div className="w-full md:w-5/12 ml-auto mr-auto px-4">
                                <div className="md:pr-12">
                                    <div className="text-lightBlue-600 p-3 text-center inline-flex items-center justify-center w-16 h-16 mb-6 shadow-lg rounded-full bg-lightBlue-300">
                                        <i className="fas fa-rocket text-xl"></i>
                                    </div>
                                    <h3 className="text-3xl font-semibold">A growing company</h3>
                                    <p className="mt-4 text-lg leading-relaxed text-blueGray-500">
                                        The extension comes with three pre-built pages to help you
                                        get started faster. You can change the text and images and
                                        you're good to go.
                                    </p>
                                    <ul className="list-none mt-6">
                                        <li className="py-2">
                                            <div className="flex items-center">
                                                <div>
                                                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                                                        <i className="fas fa-fingerprint"></i>
                                                    </span>
                                                </div>
                                                <div>
                                                    <h4 className="text-blueGray-500">
                                                        Carefully crafted components
                                                    </h4>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="py-2">
                                            <div className="flex items-center">
                                                <div>
                                                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                                                        <i className="fab fa-html5"></i>
                                                    </span>
                                                </div>
                                                <div>
                                                    <h4 className="text-blueGray-500">
                                                        Amazing page examples
                                                    </h4>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="py-2">
                                            <div className="flex items-center">
                                                <div>
                                                    <span className="text-xs font-semibold inline-block py-1 px-2 uppercase rounded-full text-lightBlue-600 bg-lightBlue-200 mr-3">
                                                        <i className="far fa-paper-plane"></i>
                                                    </span>
                                                </div>
                                                <div>
                                                    <h4 className="text-blueGray-500">
                                                        Dynamic components
                                                    </h4>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}

                <section className="pb-20 relative block bg-blueGray-800">
                    {/* <div
                        className="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
                        style={{ transform: "translateZ(0)" }}
                    >
                        <svg
                            className="absolute bottom-0 overflow-hidden"
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="text-blueGray-800 fill-current"
                                points="2560 0 2560 100 0 100"
                            ></polygon>
                        </svg>
                    </div> */}

                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap text-center justify-center">
                            <div className="w-full lg:w-6/12 px-4">
                                <h2 className="text-4xl font-semibold text-white mt-8">
                                    Join Us Today
                                </h2>
                                <p className="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400 mb-8">
                                    {/* Come join the team of EA Kampala and be a part of the movement seeking to do the most good for the future of humanity. We are a group of young, dynamic and creative individuals who are passionate about the development of the society. */}
                                    Our Next Cohort Begins in January 2023
                                </p>
                                <a
                                    className="ea-blue text-white w-3/12 p-4 outline-none focus:outline-none"
                                    style={{
                                        borderRadius: "24px",
                                        cursor: "pointer",
                                    }}
                                    href="https://fps2mesthin.typeform.com/to/GNGoQrfk"
                                    target={'_blank'}
                                    rel="noreferrer"
                                    hidden
                                >
                                    Register Today
                                </a>
                                <p
                                    className="text-lg leading-relaxed mt-4 mb-4 text-blueGray-400 mb-8"
                                >
                                    Checkout Out EA Makerere While You're Here
                                </p>
                                <a
                                    className="ea-blue text-white w-3/12 p-4 outline-none focus:outline-none"
                                    style={{
                                        borderRadius: "24px",
                                        cursor: "pointer",
                                    }}
                                    href="https://ea-makerere.vercel.app"
                                    target={'_blank'}
                                    rel="noreferrer"
                                >
                                    Visit EA Makerere
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="pt-20 pb-16 bg-white">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap justify-center text-center mb-16">
                            <div className="w-full lg:w-6/12 px-4">
                                <h2 className="text-4xl font-semibold">EA Kampala Members</h2>
                                <p className="text-lg leading-relaxed m-4 text-blueGray-500">
                                    EA Kampala is a community of people looking to do the most good with our careers and time.
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap mx-auto text-center">
                            <div className="w-1/2 lg:mb-0 mb-12 px-4">
                                <div className="px-6">
                                    <img
                                        alt="..."
                                        src={f1}
                                        className="shadow-lg rounded-full mx-auto max-w-120-px"
                                        style={{
                                            maxHeight: "150px",
                                            maxWidth: "220px",
                                            // crop the image to fit
                                            objectFit: "cover",
                                        }}
                                    />
                                    <div className="pt-6 text-center">
                                        <h5 className="text-xl font-bold">Barbara Kayondo</h5>
                                        <p className="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                            Facilitator
                                        </p>
                                        <div className="mt-6">
                                            <button
                                                className="bg-emerald-500 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                                                type="button"
                                                onClick={() => {
                                                    window.open("tel:+256392161", "_self");
                                                }}
                                            >
                                                <i className="fas fa-phone"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="w-1/2 lg:mb-0 mb-12 px-4">
                                <div className="px-6">
                                    {/* <img
                                        alt="..."
                                        src={f1}
                                        className="shadow-lg rounded-full mx-auto max-w-120-px"
                                        style={{
                                            maxHeight: "180px",
                                            maxWidth: "220px",
                                            objectFit: "cover",
                                        }}
                                    /> */}
                                    {/* fas person icon as img */}
                                    <img
                                        alt="..."
                                        src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxIQEA0SEhANFRIPDQ4PEBAPDw8PDw8PFRUYFxUVFRUYHSggGBolGxUVITEhJSkrLi4uFx8zODMtNygtLisBCgoKBQUFDgUFDisZExkrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrK//AABEIAOEA4QMBIgACEQEDEQH/xAAbAAEBAAMBAQEAAAAAAAAAAAAAAQIFBgQDB//EADkQAQEAAQICBgcGBAcBAAAAAAABAgMRBDEFBhIhQVFhcYGRobHBIjJCUnLRE2Jz8CMzQ4KSsuGi/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AP3FjaXJZASRkigAAAgG6iAoAAFAYWrasgEiooAAAIBuogKAABaAJ2vWASKACKACVJdwVQAABFHi43pLT05zly8Mcbvfb5A9qOU4jpbVzv3rjPLDu+PN8pxurP8AV1f+eVB2EiuX0emtXHnccp/NJ842fDdO6eXdnLjfP72Pvnf8AbVGOlq45TfHKWecsrMATIneAoAAAiiUFTmKCdkUAEUAEAFATdRAVMrJLb3STe28pFc/05x/at08b9nG/bv5svL1T++QPj0r0rdS3HC2YcvK5+v0ehrFqAAAAAy09S43fG2XzlsrY6HTmrjz7OXrm198awBvsOsE8dO+zKX6Pb0d0hNbt7Y2dns772d++/7OUdL1f0OzpXK89S7z9M7p9feDaAgKDG0GQkUEUABAFQUEVFAAACsd9weXpLiv4enlfHlj67/dcna3nWXLaaWPncsr7NpPnWiAAAAAAAAAdrw+pMsMMpyuMs9E8nFOo6Az30cf5csp8d/qDYlS1OYJvuykNgFAAAAE3AUABFABKQBQBoes079H1Z/RpHQdZcPsaeXlnZ75v9HPgAlBRFAAAAAdH1cv+Fl/Vvyxc46Tq5P8LL+pflAbRQAABFEyBUIoAAAigDG1cYAoAiiA8HTuG+hn/Lccvjt9XLOr6Z15ho5y/jlwxnpscoAAAAAAALIlAdR0DhtoY+nLK/Hb6OXdR0FrY5aOMl78N5lPLe2wGwUQFBAFAEUABAFYWm+7KQDGKigAAAgNP1ln2NO+Hbs+H/jn3UdPafa0cv5bjl9L8LXLgAAAQBlO45eXJiBaAA3nVif51/pz/s0bperultpW/nzt9k7vpQbQEAUQFAABLQUY9oBkAAmygIqVMfSCqAMNbTmWOWN5ZY2X2uM1tK4ZZY3njbK7ZpusXC74zUk78e7L043l7r8wc+AAQAAAAAXTxuVkk77ZJPTXZ8NpTDDDGfhxk9fpajq/wv2bqWTe3bDfwk536exu4AoAAAiiUFTYigAACKAIoAAIogKw19KZ45Y3lljZ72e7G0HE543G2XnLZfXEbfrBwfZympOWXdl6MvP2/RqAAAAACTeyTnbtPWNj0Fw/b1ZfDTna9vh+/sB0fCaP8PDDH8uMnrvjfe+oAiiAom7HmDJUkUEFABNgFQUEiosAAAEqcwTfdlIqA+HGZYdmY6lm2pezN+W/Pn4OW47g8tLO43lzxy8Mp+7c9Zf8vT/qfStXo8dvj/D1Zc8PC/jw9ONB4h99bh9u/HKZY+c5z9WPOfJ8AAAG+6szu1fXh9Whbvqzl3609GF+YN8AAlpakgJO9mICgAAACAKAAACKlIAoAPF0rxv8HCWSXLK9mb8p6XtaDrLq9+nj5TLK+3unyoNVxHEZ6l3yytvwnqj5CUFl27xFAAAfTQ1ssMpljbLPGeXlfN8wHVdEcfdbG9qSZY2S7crLyr3ue6t6smWpj45Y42ezff5uggCgAACCpl6AWoT4qAAAIbgqbpaxz1McJ9rLGeuyA+kHi1OldHH/AFJf0y5fJ58+ntOcsdS+ySfGg2ha0Or1gy/DhjPTlbl8Js1nE8Zqan3srZ+Wd2PugN9x3TWGG8w2yy/+J7fH2Od19bLPK5ZXe3mwAAAAAAIAMuTG0GWnncbLLZZd5Z4Vv+B6bxy2mp9m/m/Df2c8A7fHLfayyy8rOVZON4bi89P7uVno5432NpodYLPv4b+nC7fC/uDfDXaXTWjeeWWP6sb9N3ow4/Sy5amn/wApPmD0Kxwzl5WX1WVkAigAmwCvNxfFY6eNyyvd4Txt8o+ueW0tt7sZbb5SOS4/i7q53K8uWM8sQejiul9TPeY3sY+WN+17b+zwW7997753vqAAAAAAAAAAEAZb7Fu3JiAAAAAAAAC43bvm8vnO6vdwvS+rhtve1PLLvvv5vAA7DgeNx1pvjznPG849Li+F4i6eeOWPOeHnPGV2OlqzLHHKcssZZ6qDMTv9ADWdYdfs6UxnPUy2/wBs779Pe5psunuI7ertL3ac7P8Au8fpPY1oAAAJAUAAAAAAAAAAAACAAAAAAykAkdF1e1+1p3Hxwu0/Te+fHdzlr39CcR2NWb3uznZvr8Pj8wdSADiNTnl66xAAACFAAAAAAgAlUAAAAAIlAFAAABcVz+kUBhQAdkAD/9k="
                                        className="shadow-lg rounded-full mx-auto max-w-120-px"
                                        style={{
                                            maxHeight: "150px",
                                            maxWidth: "220px",
                                            // crop the image to fit
                                            objectFit: "cover",
                                        }}
                                    />
                                    <div className="pt-6 text-center">
                                        <h5 className="text-xl font-bold">Moses Tuhame</h5>
                                        <p className="mt-1 text-sm text-blueGray-400 uppercase font-semibold">
                                            Facilitator
                                        </p>
                                        <div className="mt-6" hidden>
                                            <button
                                                className="bg-emerald-500 text-white w-8 h-8 rounded-full outline-none focus:outline-none mr-1 mb-1"
                                                type="button"
                                                onClick={() => {
                                                    window.open("tel:+256392161", "_self");
                                                }}
                                            >
                                                <i className="fas fa-phone"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section className="relative block py-24 lg:pt-0 bg-blueGray-800">
                    <div className="container mx-auto px-4">
                        <div className="flex flex-wrap justify-center lg:-mt-64 -mt-48">
                            <div className="w-full lg:w-6/12 px-4">
                                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200">
                                    <div className="flex-auto p-5 lg:p-10">
                                        <h4 className="text-2xl font-semibold">
                                            Want to work with us?
                                        </h4>
                                        <p className="leading-relaxed mt-1 mb-4 text-blueGray-500">
                                            Complete this form and we will get back to you in 24
                                            hours.
                                        </p>
                                        <div className="relative w-full mb-3 mt-8">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="full-name"
                                            >
                                                Full Name
                                            </label>
                                            <input
                                                type="text"
                                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                placeholder="Full Name"
                                            />
                                        </div>

                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="email"
                                            >
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                placeholder="Email"
                                            />
                                        </div>

                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="message"
                                            >
                                                Message
                                            </label>
                                            <textarea
                                                rows="4"
                                                cols="80"
                                                className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                                                placeholder="Type a message..."
                                            />
                                        </div>
                                        <div className="text-center mt-6">
                                            <button
                                                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                                type="button"
                                            >
                                                Send Message
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> */}
            </main>
            {/* <Footer /> */}
        </>
    );
}
